
import React, { useRef, useEffect } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { useIsMobile } from '@/hooks/use-mobile';

interface CompanySearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onSearch: (e: React.FormEvent) => void;
  isShareFlow: boolean;
  isLoading?: boolean;
}

const CompanySearch = ({ searchTerm, onSearchChange, onSearch, isShareFlow, isLoading = false }: CompanySearchProps) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const isMobile = useIsMobile();

  // Focus on search input if in share flow
  useEffect(() => {
    if (isShareFlow && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isShareFlow]);

  const placeholderText = isMobile 
    ? "Company Name..." 
    : (isShareFlow ? "Search for the company you worked at..." : "Search by company name...");

  return (
    <form onSubmit={onSearch} className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-redflags-gray w-5 h-5" />
      <Input
        ref={searchInputRef}
        id="company-search"
        type="text"
        placeholder={placeholderText}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-10 py-6 text-lg focus-visible:ring-redflags-red/30"
      />
      <Button 
        type="submit"
        className="absolute right-1 top-1/2 transform -translate-y-1/2 bg-redflags-red hover:bg-redflags-red/90"
        disabled={isLoading}
      >
        {isLoading ? <Spinner className="w-4 h-4" /> : 'Search'}
      </Button>
    </form>
  );
};

export default CompanySearch;
